import { combineReducers } from 'redux'
import g2pdata from './g2pdata'

const g2pApp = combineReducers({
  g2pdata
})

export default g2pApp



// WEBPACK FOOTER //
// ./src/reducers/index.js